// React and React-related libraries
import { useState, useEffect } from 'react';
// Material-UI components and functions
import {
    Typography,
    FormControl,
    TextField,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    IconButton,
    Autocomplete
} from '@mui/material';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
// Third-party libraries
import { v4 as uuidv4 } from 'uuid';
// Project-specific components and functions
import { Designations } from 'components/modalKYX/Designations';
import { KYB, Analytics, KYC } from 'lib/api';
import { KYBStepBanner } from './KYBStepBanner';
import { KYX_ANALYTICS_EVENTS } from '../StartKYX';
import AddOwner from './AddOwner';
import CircularComponent from 'components/shared/CircularComponent';
import StatusSnackbar from 'components/shared/StatusSnackbar';

const useStyles = makeStyles(theme => ({
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    phoneBox: {
        marginTop: '2em'
    },
    phoneInput: {
        width: '50%'
    },
    verifyButton: {
        color: 'white!important',
        borderRadius: '25px!important',
        padding: '.5em 3em!important',
        margin: '.5em!important',
        background: '#1BABE2!important'
    },
    inputFormControl: {
        background: '#FFFFFF',
        border: '1px solid #D8DDE2',
        boxSizing: 'border-box',
        borderRadius: '3px',
        marginTop: '10px',
        width: '100%!important',
        height: '40px'
    },
    contactInforFormLabel: {
        color: '#225384',
        fontWeight: 600
    },
    businessAdressBox: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2,1fr)',
        rowGap: '1em',
        columnGap: '1em'
    },
    formControl: {
        width: '100%!important'
    },
    informationOptions: {
        marginTop: '5em',
        paddingBottom: '2em',
        display: 'flex',
        justifyContent: 'space-between'
    },
    next: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 3em!important',
        background: '#1BABE2!important'
    },
    businessOwnerFields: {
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '1em'
        },
        [theme.breakpoints.up('md')]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2,1fr)',
            rowGap: '1em',
            columnGap: '1em'
        }
    },
    inputOwnership: {
        '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            appearance: 'none',
            margin: 0
        }
    }
}));

export const KYBFifthStep = ({
    handleClose,
    incrementPage,
    activePage,
    decreasePage,
    handleInputChange,
    formValues,
    setFormValues,
    ownersArray,
    setOwnersArray,
    ownOwner,
    setOwnOwner,
    radioOwner,
    setRadioOwner
}) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [showOwners, setShowOwners] = useState(false);
    const [errorOwnership, setErrorOwnership] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [totalOwnership, setTotalOwnership] = useState(0);
    const [actualJobTitle, setActualJobTitle] = useState('');
    const [label, setLabel] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    const initialDesignation = Designations.find(designation => designation.label === actualJobTitle);

    useEffect(() => {
        setSelectedValue(initialDesignation);
        handleOwnChange('title', initialDesignation);
    }, [initialDesignation]);

    useEffect(() => {
        (async () => {
            const response = await KYC.retrieveKYC();
            setActualJobTitle(response.job_title);
        })();
    }, []);

    useEffect(() => {
        document.getElementById('kyb-taxheader')?.scrollIntoView();
    }, []);

    useEffect(() => {
        if (ownersArray?.length) {
            setShowOwners(true);
        }
    }, [ownersArray, formValues, setFormValues]);

    const incrementStep = () => {};

    const setBusinessRadio = event => {
        if (ownOwner?.id) return;
        if (event.target.value === 'yes') {
            setRadioOwner(true);
        } else {
            setRadioOwner(false);
        }
    };

    const sendInfo = () => {
        let promises = [];
        let ownershipTotal = 0;
        setLoading(true);
        if (radioOwner) {
            var payload = {
                title: ownOwner.title.label,
                ownership: parseInt(ownOwner.ownership),
                designation: ownOwner.title.value
            };
            ownershipTotal += payload.ownership;
            promises.push(KYB.postOwner(payload));
        }
        for (let i = 0; i < ownersArray.length; i += 1) {
            const item = ownersArray[i];
            ownershipTotal += parseInt(item.ownership);
        }

        if (ownershipTotal > 100) {
            setLoading(false);
            setLabel("Ownership can't be higher than 100%");
            setOpenAlert(true);
        }

        const ownersCopy = ownersArray.map(item => ({ ...item }));
        promises.push(
            ...ownersArray.map(item => {
                if (item.completed) return Promise.resolve();
                const newItem = {
                    title: item.title,
                    designation: item.designation,
                    ownership: parseInt(item.ownership),
                    first_name: item.first_name,
                    last_name: item.last_name,
                    email: item.email,
                    phone_number: '+1' + item.phone_number,
                    date_of_birth: item.date_of_birth,
                    ssn: item.ssn,
                    address: {
                        line1: item.bus_line_1,
                        line2: item.bus_line_2,
                        state: item.bus_state,
                        city: item.bus_city,
                        postalCode: item.bus_PO
                    }
                };

                return KYB.postNotOwner(newItem);
            })
        );
        let hasError = false;
        let Errors = [];
        Promise.allSettled(promises)
            .then(values => {
                for (let i = 0; i < values.length; i++) {
                    const promise = values[i];
                    if (promise.status === 'rejected') {
                        hasError = true;
                        Errors.push(promise);
                        if (radioOwner && i > 0) {
                            ownersCopy[i - 1].error = true;
                        } else if (!radioOwner) {
                            ownersCopy[i].error = true;
                        }
                    } else {
                        if (radioOwner && i > 0) {
                            ownersCopy[i - 1].completed = true;
                        } else if (!radioOwner) {
                            ownersCopy[i].completed = true;
                        }
                    }
                }

                setOwnersArray(ownersCopy);
                if (hasError) {
                    setLoading(false);
                    throw Errors[0]['reason'];
                } else {
                    const body = {
                        step: KYX_ANALYTICS_EVENTS.STEP_7,
                        eventData: payload
                    };
                    Analytics.createKYXEvent(body).catch(error => console.error(error));
                    incrementPage();
                }
            })
            .catch(error => {
                if (error.response.data.type === 'Owner/PhoneNumberExists') {
                    setLoading(false);
                    setLabel('Phone number already exists');
                    setOpenAlert(true);
                    return;
                }
                setLoading(false);
                setLabel(error.response.data.message);
                setOpenAlert(true);
            });
    };

    const addMoreOwner = () => {
        setOwnersArray(currentOwners => [
            ...currentOwners,
            {
                id: uuidv4(),
                title: '',
                ownership: '',
                first_name: '',
                last_name: '',
                phone_number: '',
                email: '',
                date_of_birth: null,
                ssn: '',
                bus_line_1: '',
                bus_line_2: '',
                bus_city: '',
                bus_state: '',
                bus_PO: ''
            }
        ]);
    };

    const addAnotherOwner = () => {
        setShowOwners(true);
        addMoreOwner();
    };

    const removeOwner = owner => {
        const newOwnersArray = ownersArray.filter((item, index) => item.id !== owner.id);
        setOwnersArray(newOwnersArray);
    };

    const handleOwnChange = (field, value) => {
        setOwnOwner({
            ...ownOwner,
            [field]: value
        });
    };

    const nextIsDisabled = () => {
        if (radioOwner) {
            if (ownersArray.length === 0) {
                return !selectedValue || !ownOwner?.ownership || errorOwnership;
            }
            const hasInvalidOwner = ownersArray.filter(item => !item.isValid);
            return hasInvalidOwner.length > 0 || !selectedValue || !ownOwner?.ownership || errorOwnership;
        } else {
            const hasInvalidOwner = ownersArray.filter(item => !item.isValid);
            return ownersArray.length === 0 || hasInvalidOwner.length > 0 || errorOwnership;
        }
    };

    const sumOwnerships = () => {
        let total = 0;
        if (radioOwner) {
            total += parseInt(ownOwner?.ownership);
        }
        for (let i = 0; i < ownersArray.length; i++) {
            const item = ownersArray[i];
            total += parseInt(item.ownership);
        }
        return total;
    };
    useEffect(() => {
        setTotalOwnership(sumOwnerships());
        if (totalOwnership > 100) {
            setErrorOwnership(true);
        } else {
            setErrorOwnership(false);
        }
    }, [radioOwner, ownOwner, ownersArray, totalOwnership]);

    return (
        <Box className={classes.dialogBody}>
            <KYBStepBanner activeStep={activePage} incrementStep={() => incrementStep()} />
            <Box className={classes.content}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="h5" className={classes.contentTitle}>
                            Ownership Status
                        </Typography>
                        <Typography variant="subtitle1" style={{ color: '#A8B6C1' }}>
                            This will help us verify your business quickly
                        </Typography>
                    </Box>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        sx={{ alignSelf: 'flex-start' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box
                    style={{
                        background: '#F1F3F7',
                        borderRadius: '4px',
                        marginTop: '32px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    sx={{
                        maxWidth: {
                            lg: '549px',
                            md: 'auto',
                            sm: 'auto',
                            xs: 'auto'
                        },
                        maxHeight: {
                            lg: '140px',
                            md: 'auto',
                            sm: 'auto',
                            xs: 'auto'
                        }
                    }}>
                    <label
                        style={{
                            fontFamily: 'Montserrat',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: '13px',
                            lineHeight: '20px',
                            color: '#182D55',
                            padding: '.5em 1em'
                        }}>
                        Please list any individual who:
                    </label>
                    <label
                        style={{
                            fontFamily: 'Montserrat',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '13px',
                            lineHeight: '20px',
                            color: '#7D95A5',
                            padding: '.5em 1em'
                        }}>
                        <span>&#183;</span> Owns 25% or more of the business
                    </label>
                    <label
                        style={{
                            fontFamily: 'Montserrat',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '13px',
                            lineHeight: '20px',
                            color: '#7D95A5',
                            padding: '.5em 1em'
                        }}>
                        Or
                    </label>
                    <label
                        style={{
                            fontFamily: 'Montserrat',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '13px',
                            lineHeight: '20px',
                            color: '#7D95A5',
                            padding: '.5em 1em'
                        }}>
                        <span>&#183;</span> Will have significant responsibility in managing the account with Paystand
                    </label>
                </Box>
                <Box marginTop="20px" flexDirection="column">
                    <FormControl style={{ width: '100%' }}>
                        <Typography variant="subtitle2">Are you a business owner?</Typography>
                        <FormControl
                            style={{
                                flexDirection: 'row'
                            }}>
                            <RadioGroup row name="row-radio-buttons-group" defaultValue="yes">
                                <FormControlLabel
                                    name="radio-buttons"
                                    value="yes"
                                    disabled={ownOwner?.id}
                                    onClick={event => setBusinessRadio(event)}
                                    checked={radioOwner}
                                    control={
                                        <Radio
                                            size="small"
                                            style={{
                                                fontFamily: 'Montserrat',
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                fontSize: '13px',
                                                lineHeight: '20px',
                                                color: '#172C56'
                                            }}
                                        />
                                    }
                                    label="Yes"
                                />
                                <FormControlLabel
                                    name="radio-buttons"
                                    value="no"
                                    disabled={ownOwner?.id}
                                    onClick={event => setBusinessRadio(event)}
                                    checked={!radioOwner}
                                    control={
                                        <Radio
                                            size="small"
                                            style={{
                                                fontFamily: 'Montserrat',
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                fontSize: '13px',
                                                lineHeight: '20px',
                                                color: '#172C56'
                                            }}
                                        />
                                    }
                                    label="No"
                                />
                            </RadioGroup>
                        </FormControl>
                    </FormControl>
                </Box>
                {!radioOwner ? (
                    <Box>
                        {
                            <Box>
                                {ownersArray.map((item, index) => {
                                    return (
                                        <AddOwner
                                            key={item.id}
                                            owner={item}
                                            setOwnersArray={setOwnersArray}
                                            lbl={index + 1}
                                            number={index}
                                            removeOwner={removeOwner}
                                            setSelectedIndex={setSelectedIndex}
                                            selectedIndex={selectedIndex}
                                            selectedOption={radioOwner}
                                            setTotalOwnership={setTotalOwnership}
                                            totalOwnership={totalOwnership}
                                            setErrorOwnership={setErrorOwnership}
                                        />
                                    );
                                })}
                            </Box>
                        }
                        <Button
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '2em',
                                cursor: 'pointer'
                            }}
                            onClick={() => addMoreOwner()}>
                            <AddIcon />
                            Add another business owner
                        </Button>
                    </Box>
                ) : (
                    <Box>
                        <Typography variant="subtitle3">BUSINESS OWNER 1 (YOU)</Typography>
                        <Box className={classes.businessOwnerFields}>
                            <Box flexDirection="column">
                                <FormControl className={classes.formControl}>
                                    <Typography variant="subtitle2">Job Title</Typography>
                                    <Autocomplete
                                        disablePortal
                                        id="bus_job_title"
                                        autoSelect={true}
                                        options={Designations}
                                        sx={{ gridColumn: '2/3' }}
                                        renderInput={params => <TextField {...params} placeholder="Select job title" />}
                                        onChange={(event, option) => {
                                            handleOwnChange('title', option);
                                            setSelectedValue(option);
                                        }}
                                        getOptionLabel={option => option?.label || ''}
                                        value={selectedValue || ''}
                                        size="small"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Box>
                            <Box flexDirection="column">
                                <FormControl className={classes.formControl}>
                                    <Typography variant="subtitle2">% Beneficial Ownership</Typography>
                                    <TextField
                                        id="bus_benefitial_porcentage"
                                        error={errorOwnership}
                                        placeholder="Enter %"
                                        variant="outlined"
                                        type="number"
                                        onBlur={e => {
                                            let value = Math.round(e.target.value);
                                            if (value < 1) {
                                                value = 1;
                                            } else if (value > 100) {
                                                value = 100;
                                            }
                                            e.target.value = value;
                                            handleOwnChange('ownership', e.target.value);
                                        }}
                                        onChange={event => handleOwnChange('ownership', event.target.value)}
                                        value={ownOwner?.ownership || ''}
                                        helperText={errorOwnership ? 'Total ownership must be less than 100' : ''}
                                        size="small"
                                        className={classes.inputOwnership}
                                    />
                                </FormControl>
                            </Box>
                        </Box>
                        {showOwners ? (
                            <Box>
                                {ownersArray.map((item, index) => {
                                    return (
                                        <AddOwner
                                            key={item.id}
                                            owner={item}
                                            setOwnersArray={setOwnersArray}
                                            lbl={index + 2}
                                            number={index}
                                            removeOwner={removeOwner}
                                            setSelectedIndex={setSelectedIndex}
                                            selectedIndex={selectedIndex}
                                            selectedOption={radioOwner}
                                            setTotalOwnership={setTotalOwnership}
                                            totalOwnership={totalOwnership}
                                            setErrorOwnership={setErrorOwnership}
                                        />
                                    );
                                })}
                            </Box>
                        ) : null}
                        <Button
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '2em',
                                cursor: 'pointer'
                            }}
                            onClick={() => addAnotherOwner()}>
                            <AddIcon />
                            Add another business owner
                        </Button>
                    </Box>
                )}
                <Box className={classes.informationOptions}>
                    {loading ? (
                        <Box marginLeft="auto" sx={{ float: 'right' }}>
                            <CircularComponent />
                        </Box>
                    ) : (
                        <>
                            <Button variant="text" onClick={decreasePage}>
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                disabled={nextIsDisabled()}
                                sx={{ marginLeft: 'auto' }}
                                onClick={() => sendInfo()}>
                                Next
                            </Button>
                        </>
                    )}
                </Box>
            </Box>
            <StatusSnackbar
                label={label}
                severity={'error'}
                open={openAlert}
                setOpenAlert={setOpenAlert}
                needsAction={false}
                decreasePage={decreasePage}
            />
        </Box>
    );
};
